import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import { useAuth, AuthenticationStatus } from "../../../context/auth-context";
// import { HomeNav } from "../../nav/homeNav";
import { isMobile } from "react-device-detect";
import { Logger } from "aws-amplify";
import { signUpPath, forgotPasswordPath, authRedirectPath, signUpConfirmPath, newInformationRequiredPath } from "../../main";
import * as yup from "yup";
import { Button } from "../../../tabin/components/button";
import { Input } from "../../../tabin/components/input";
import { Link } from "../../../tabin/components/link";
import { useSmallScreen } from "../../../hooks/useWindowSize";
import { useUser } from "../../../context/user-context";

const logger = new Logger("Login");

const emailSchema = yup.string().email("Please enter a valid email address").required("Email is required");
const passwordSchema = yup.string().min(8, "Password must be at least 8 characters long").required("Password is required");

export default () => {
    const { login } = useAuth();
    const navigate = useNavigate();
    const { isSmallScreen } = useSmallScreen();

    const [loading, setLoading] = useState(false);
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");

    const [serverError, setServerError] = useState("");
    const [emailError, setEmailError] = useState("");
    const [passwordError, setPasswordError] = useState("");

    const { user } = useUser();
    const { status } = useAuth();

    useEffect(() => {
        if (status === AuthenticationStatus.SignedIn) {
            navigate(authRedirectPath, { replace: true });
        }

        if (status === AuthenticationStatus.UnconfirmedSignIn) {
            navigate(signUpConfirmPath);
        }

        if (status === AuthenticationStatus.NewInformationRequired) {
            navigate(newInformationRequiredPath);
        }
    }, [status]);

    const onChangeEmail = (event: React.ChangeEvent<HTMLInputElement>) => {
        setEmail(event.target.value.toLocaleLowerCase());
        setEmailError("");
        setServerError("");
    };

    const onChangePassword = (event: React.ChangeEvent<HTMLInputElement>) => {
        setPassword(event.target.value);
        setPasswordError("");
        setServerError("");
    };

    const onSwitchToSignUp = () => {
        navigate(signUpPath);
    };

    const onForgetPassword = () => {
        navigate(forgotPasswordPath);
    };

    const onLogin = async () => {
        setLoading(true);
        let fieldsValid = true;

        try {
            await emailSchema.validate(email);
            setEmailError("");
        } catch (e) {
            setEmailError(e.errors[0]);
            fieldsValid = false;
        }

        try {
            await passwordSchema.validate(password);
            setPasswordError("");
        } catch (e) {
            setPasswordError(e.errors[0]);
            fieldsValid = false;
        }

        if (fieldsValid) {
            try {
                await login(email, password);
                logger.debug("Successfully logged in");
                setLoading(false);
            } catch (e) {
                logger.debug("e", e);
                setServerError(e.message);
                setLoading(false);
            }
        } else {
            setLoading(false);
        }
    };

    const onEnter = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Enter") {
            onLogin();
        }
    };

    const emailInput = (
        <>
            <Input name="email" label="Email" type="text" onChange={onChangeEmail} onKeyPress={onEnter} value={email} error={emailError} />
        </>
    );

    const passwordInput = (
        <>
            <Input
                name="password"
                label="Password"
                type="password"
                onChange={onChangePassword}
                onKeyPress={onEnter}
                value={password}
                error={passwordError}
            />
        </>
    );

    const loginButton = (
        <>
            <Button style={{ borderRadius: "8px", width: "100%", height: "52px" }} disabled={loading} onClick={onLogin} loading={loading}>
                <div className="text-bold">LOG IN</div>
            </Button>
        </>
    );

    const dontHaveAnAccount = (
        <>
            <div style={{ display: "flex", alignItems: "center" }}>
                <div className="mr-1">Don't have an account?</div>
                <Link onClick={onSwitchToSignUp} style={{ marginLeft: "8px" }}>
                    Sign up
                </Link>
            </div>
        </>
    );

    const content = (
        <>
            <div
                style={
                    !isSmallScreen
                        ? {
                              padding: "24px",
                              margin: "0 auto",
                              width: "448px",
                              border: "1px solid #e4e4e4",
                          }
                        : {}
                }
            >
                <div className="h2">Log in</div>
                <div className="mb-3"></div>
                {serverError && <div className="text-error mb-3">{serverError}</div>}

                {emailInput}
                <div className="mb-2"></div>
                {passwordInput}
                <div className="mb-3"></div>
                <Link onClick={onForgetPassword}>Forgot password?</Link>
                <div className="mb-3"></div>
                {loginButton}
                <div className="separator-3"></div>
                <div className="mb-2"></div>
                {dontHaveAnAccount}
            </div>
        </>
    );

    return (
        <>
            {/* <HomeNav /> */}
            <div
                style={{
                    minHeight: "100vh",
                    maxWidth: "1080px",
                    margin: "auto",
                    padding: "24px",
                    paddingTop: isSmallScreen ? "24px" : "40px",
                    paddingBottom: isMobile ? "80px" : "unset", // for tab nav
                }}
            >
                {content}
            </div>
        </>
    );
};
